import React from "react";
import { CategoryGroupTemplate } from "themes/application/categories/components";

function CategoryGroup(props) {
    return <CategoryGroupTemplate {...props} />;
}

export default CategoryGroup;
